(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//https://qiita.com/yamanoku/items/027308e23cfc69845d7e

// import IntersectionObserver from 'intersection-observer-polyfill';
// let IntersectionObserver = require('intersection-observer-polyfill/dist/IntersectionObserver');

var observer = new IntersectionObserver(function (entries) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {

        for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var e = _step.value;


            if (e.intersectionRect.top) {
                // data-src属性の画像URLをsrcに挿入
                if (e.target.tagName === 'IMG') {
                    e.target.src = e.target.dataset.src;
                } else {
                    //SOURCE
                    e.target.srcset = e.target.dataset.src;
                }

                // 挿入し終わったら監視を終了
                observer.unobserve(e.target);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});

var imgs = [].concat(_toConsumableArray(document.querySelectorAll('.lazy-loading')));

imgs.forEach(function (img) {
    return observer.observe(img);
});

// 監視したい要素をobserveする。
// observer.observe(document.querySelectorAll('.lazy-loading'));

},{}]},{},[1]);

//# sourceMappingURL=lazy-loading.js.map
